import React from 'react';
import { Tag } from 'antd';

/**
 * Component to render license options in the select dropdown
 * Shows license name, subscription type tag, and catalog usage
 * 
 * @param {Object} license - License data object
 */
const LicenseOptionRenderer = ({ license }) => {
    const used = license.catalogRefList?.length || 0;

    // Function to map subscription type to display tag
    const getSubscriptionTypeTag = (subscriptionType) => {
        if (!subscriptionType) return null;

        const type = subscriptionType.toLowerCase();

        // Check in priority order - most specific first
        if (type.includes('additional')) {
            return <Tag color="green">Add-On</Tag>;
        }
        if (type.includes('gateway')) {
            return <Tag color="orange">Gateway</Tag>;
        }
        if (type.includes('smart')) {
            return <Tag color="purple">Smart</Tag>;
        }
        if (type.includes('branded')) {
            return <Tag color="blue">Branded</Tag>;
        }

        // Don't show tag for other types
        return null;
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
            <span>{license.name}</span>
            {getSubscriptionTypeTag(license.subscriptionType)}
            <span style={{ color: '#888', fontSize: 12 }}>
                {used} catalogues used
            </span>
        </div>
    );
};

export default LicenseOptionRenderer;
